module.exports = __webpack_public_path__ + "static/media/cc.985a76c5.svg";